export default "__VITE_ASSET__BjeQ5jxK__"